import { generatePlugin } from '~/assets/javascript/modules/auth';

export default generatePlugin;
